import React, { useState } from 'react';

const Contact = () => {
    const [formStatus, setFormStatus] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        // Form submission logic would go here
        setFormStatus('success');
        // Reset form after submission
        setTimeout(() => {
            setFormStatus('');
            e.target.reset();
        }, 3000);
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-green-50 to-teal-50 py-16 px-4 sm:px-6 lg:px-8">
            <div className="max-w-5xl mx-auto">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
                    {/* Left Column - Info */}
                    <div className="space-y-8">
                        <div className="text-left">
                            <h1 className="text-4xl sm:text-5xl font-bold mb-6 bg-gradient-to-r from-green-400 to-teal-400 bg-clip-text text-transparent">
                                Let's Grow Together
                            </h1>
                            <p className="text-lg text-gray-700 max-w-md">
                                Have questions about carbon farming or how our platform works? We're here to help you on your sustainability journey.
                            </p>
                        </div>

                        <div className="bg-white/70 backdrop-blur-sm rounded-xl shadow-lg p-6 space-y-6">
                            <div>
                                <h3 className="text-xl font-semibold text-gray-800 mb-2">Get in Touch</h3>
                                <p className="text-gray-600">We're available Monday through Friday, 9am-5pm GMT.</p>
                            </div>

                            <div>
                                <h4 className="text-teal-600 font-medium mb-1">Email</h4>
                                <p className="text-gray-700">info@spheresix.com</p>
                            </div>

                            <div>
                                <h4 className="text-teal-600 font-medium mb-1">Phone</h4>
                                <p className="text-gray-700">+44 (0) 20 7123 4567</p>
                            </div>

                            <div>
                                <h4 className="text-teal-600 font-medium mb-1">Location</h4>
                                <p className="text-gray-700">SphereSix Ltd<br />123 Sustainability Street<br />London, UK</p>
                            </div>
                        </div>

                        <div className="bg-gradient-to-r from-green-400 to-teal-400 rounded-xl shadow-lg p-6 text-white">
                            <h3 className="text-xl font-semibold mb-3">Our Mission</h3>
                            <p>At SphereSix, we're committed to making sustainability accessible and profitable for farmers. Every inquiry is an opportunity to grow our community of forward-thinking agricultural partners.</p>
                        </div>
                    </div>

                    {/* Right Column - Form */}
                    <div className="bg-white/80 backdrop-blur-md rounded-xl shadow-lg p-8">
                        <h2 className="text-2xl font-bold text-gray-800 mb-6">Send Us a Message</h2>
                        
                        {formStatus === 'success' ? (
                            <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative mb-6">
                                <strong className="font-bold">Thank you!</strong>
                                <span className="block sm:inline"> Your message has been sent. We'll be in touch soon.</span>
                            </div>
                        ) : null}
                        
                        <form onSubmit={handleSubmit} className="space-y-6">
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                <div>
                                    <label htmlFor="firstName" className="block text-sm font-medium text-gray-700 mb-1">First Name *</label>
                                    <input
                                        type="text"
                                        id="firstName"
                                        name="firstName"
                                        required
                                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-teal-400 focus:border-transparent"
                                    />
                                </div>
                                <div>
                                    <label htmlFor="lastName" className="block text-sm font-medium text-gray-700 mb-1">Last Name *</label>
                                    <input
                                        type="text"
                                        id="lastName"
                                        name="lastName"
                                        required
                                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-teal-400 focus:border-transparent"
                                    />
                                </div>
                            </div>
                            
                            <div>
                                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">Email Address *</label>
                                <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    required
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-teal-400 focus:border-transparent"
                                />
                            </div>
                            
                            <div>
                                <label htmlFor="farmSize" className="block text-sm font-medium text-gray-700 mb-1">Farm Size (acres)</label>
                                <input
                                    type="number"
                                    id="farmSize"
                                    name="farmSize"
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-teal-400 focus:border-transparent"
                                />
                            </div>
                            
                            <div>
                                <label htmlFor="inquiryType" className="block text-sm font-medium text-gray-700 mb-1">Inquiry Type *</label>
                                <select
                                    id="inquiryType"
                                    name="inquiryType"
                                    required
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-teal-400 focus:border-transparent"
                                >
                                    <option value="">Select an option</option>
                                    <option value="calculator">Carbon Calculator</option>
                                    <option value="credits">Carbon Credits</option>
                                    <option value="partnership">Business Partnership</option>
                                    <option value="support">General Support</option>
                                    <option value="other">Other</option>
                                </select>
                            </div>
                            
                            <div>
                                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">Your Message *</label>
                                <textarea
                                    id="message"
                                    name="message"
                                    rows="4"
                                    required
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-teal-400 focus:border-transparent"
                                ></textarea>
                            </div>
                            
                            <div className="flex items-center">
                                <input
                                    id="newsletter"
                                    name="newsletter"
                                    type="checkbox"
                                    className="h-4 w-4 text-teal-500 focus:ring-teal-400 border-gray-300 rounded"
                                />
                                <label htmlFor="newsletter" className="ml-2 block text-sm text-gray-700">
                                    Keep me updated on SphereSix news and developments
                                </label>
                            </div>
                            
                            <div>
                                <button
                                    type="submit"
                                    className="w-full py-3 px-6 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-gradient-to-r from-green-400 to-teal-400 hover:from-green-500 hover:to-teal-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500 transition-all duration-300"
                                >
                                    Send Message
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;